<script lang="ts">import { BaseAtom } from "components/cards/atoms";
import { WebEmbedParticle, WebEmbedParticleSpec } from "components/cards/particles/YinzCam";
export let container = undefined;
export let rendererUrl = "";
export let _isotope = "GraffitiCard";
export let _saveMetadata = (metadata) => { };
let _clientHeightPx = 0;
let _clientWidthPx = 0;
$: if (_saveMetadata && _clientHeightPx > 0 && _clientWidthPx > 0) {
    _saveMetadata({ clientHeightPx: _clientHeightPx, clientWidthPx: _clientWidthPx });
}
</script>

<style></style>

<BaseAtom _isotope={_isotope} bind:_clientHeightPx bind:_clientWidthPx {...container}>
  <WebEmbedParticle _block={true} {...WebEmbedParticleSpec.propsWithDefaults({ container: { fillWidth: true }, source: rendererUrl, noDefaultStyling: true })} />
</BaseAtom>
